import React, { useState } from 'react';
import styles from '../../styles/Roommates/ApprovalVotes.module.css';

const approvalRequests = [
  {
    unitId: '7B',
    address: '75 Main St',
    neighborhood: 'Beacon Hill',
    rent: 2500,
    proposedBy: 'Olivia',
    votes: { You: 'pending', Olivia: 'approved' },
    cosigner: { name: 'Alex', threshold: 3000 },
    tour: { completed: true, by: 'You', date: 'Feb 24, 3:00 PM' },
  },
  {
    unitId: '12A',
    address: '320 Beacon St',
    neighborhood: 'Back Bay',
    rent: 3200,
    proposedBy: 'Alex',
    votes: { You: 'pending', Olivia: 'pending' },
    cosigner: { name: 'Alex', threshold: 3000 },
    tour: { completed: false },
  },
];

const ApprovalVotes = () => {
  const [isOpen, setIsOpen] = useState(false); // Collapsed by default

  return (
    <div className={styles.approvalVotes}>
      <h3 className={styles.collapsibleHeader} onClick={() => setIsOpen(!isOpen)}>
        Unit Approval Requests {isOpen ? '▴' : '▾'}
      </h3>

      {isOpen && (
        <div className={styles.requestsContainer}>
          {approvalRequests.map((unit) => (
            <div key={unit.unitId} className={styles.unitCard}>
              <div className={styles.unitDetails}>
                <div className={styles.unitName}>{unit.unitId} – {unit.address}</div>
                <div className={styles.neighborhood}>{unit.neighborhood}</div>
                <div className={styles.proposedBy}>
                  Proposed by: <strong>{unit.proposedBy}</strong>
                </div>
                <div className={styles.tourInfo}>
                  {unit.tour.completed
                    ? `Tour: ✅ by ${unit.tour.by} (${unit.tour.date})`
                    : 'No tour yet'}
                </div>
              </div>

              <div className={styles.votesSection}>
                {Object.entries(unit.votes).map(([person, vote]) => (
                  <div key={person} className={styles.voteItem}>
                    {person}:
                    <span className={`${styles.voteBadge} ${styles[vote]}`}>
                      {vote === 'approved' && '✅ Yes'}
                      {vote === 'pending' && '❓ Pending'}
                    </span>
                  </div>
                ))}
                <div className={styles.voteItem}>
                  {unit.cosigner.name}:
                  {unit.rent <= unit.cosigner.threshold ? (
                    <span className={styles.voteBadgeGood}>✅ Within Limit</span>
                  ) : (
                    <span className={styles.voteBadgeWarn}>⚠️ Over Limit</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ApprovalVotes;
